import React from 'react';

const StopwatchFillSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <defs>
            <path
                id="stopwatch-fill_svg__a"
                d="M8.5 4.025V3h1a1.5 1.5 0 1 0 0-3h-3a1.5 1.5 0 1 0 0 3h1v1.025C3.316 4.285 0 7.75 0 12a8 8 0 0 0 8 8 8 8 0 0 0 8-8c0-4.25-3.316-7.715-7.5-7.975zm-5.793.682L2 4 0 6l.707.707 2-2zm4.94 6.94l.707.707 4-4-.707-.707-4 4z"
            />
        </defs>
        <g fill="none" fillRule="evenodd" transform="translate(4 2)">
            <mask id="stopwatch-fill_svg__b" fill="#fff">
                <use xlinkHref="#stopwatch-fill_svg__a" />
            </mask>
            <use fill="#45494E" xlinkHref="#stopwatch-fill_svg__a" />
            <g mask="url(#stopwatch-fill_svg__b)">
                <path fill="#000" d="M-4-2h24v24H-4z" />
            </g>
        </g>
    </svg>
);

StopwatchFillSvg.displayName = 'StopwatchFillSvg';
export default StopwatchFillSvg;
